import React, { useEffect, useState } from "react";
import { Table, Tag, Button, Select, Input, DatePicker } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import newDateTime from "controllers/newDateTime";

const AccessMenuHistory = ({ adminManageInfo }) => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1, // 현재 표시할 페이지
      pageSize: 10, // 한 페이지에 표시할 레코드 수
    },
  });
  const [filter, setFilter] = useState({
    status: "전체",
    dateRange: null,
    search: "",
  });
  // console.log(adminManageInfo);
  const columns = [
    {
      title: "NO",
      dataIndex: "rowKey",
      width:"100px"
    },
    {
      title: "메뉴 접속 일시",
      dataIndex: "access_datetime",
      width: "200px"
    },
    {
      title: "접속 IP",
      dataIndex: "ip_address",
      width: "150px"
    },
    {
      title: "접속 메뉴",
      dataIndex: "ADMIN_Menu_name",
      width: "120px"
    },
    {
      title: "계정(이메일)",
      dataIndex: "ADMIN_User_email",
      width: "200px"
    },
    {
      title: "이름",
      dataIndex: "ADMIN_User_name",
      width: "120px"
    },
    {
      title: "계정 상태",
      dataIndex: "ADMIN_User_status",
      render: (_) => (_ === "1" ? "정상" : "해지"),
    },
  ];


  const fetchData = () => {
    setLoading(true);

    const dataSource = adminManageInfo.history.reduce((acc, ele, idx) => {

      const statusFilter =
        filter.status === "전체"
          ? true
          : filter.status === ele.ADMIN_User_status
          ? true
          : false;
      // console.log(filter.dateRange)
      const dateRangeFilter =
        filter.dateRange === null
          ? true
          : filter.dateRange[0] <= new Date(ele.access_datetime) &&
            filter.dateRange[1] > new Date(ele.access_datetime)
          ? true
          : false;

      const searchFilter =
        filter.search === ""
          ? true
          : ele.ADMIN_User_name.includes(filter.search) ||
            ele.ADMIN_User_email.includes(filter.search)
          ? true
          : false;

      // const rowKey = acc.length + 1;
      const rowKey = adminManageInfo.history.length - idx;

      if (statusFilter && dateRangeFilter && searchFilter) {

        acc.push({
          rowKey: rowKey,
          index: idx,
          ADMIN_Menu_id: ele.ADMIN_Menu_id,
          ADMIN_Menu_name: ele.ADMIN_Menu_name,
          ADMIN_User_email: ele.ADMIN_User_email,
          ADMIN_User_id: ele.ADMIN_User_id,
          ADMIN_User_name: ele.ADMIN_User_name,
          ADMIN_User_status: ele.ADMIN_User_status,
          access_datetime: newDateTime(ele.access_datetime),
          id: ele.id,
          ip_address: ele.ip_address,
        });
      }
      return acc;
    }, []);

    dataSource.forEach((ele,idx)=>{
      ele.rowKey = dataSource.length - idx
      return ele
    })

    setData(dataSource);
    setLoading(false);
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        // total: 100, //전체 레코드 수(페이지 숫자 표시를 위해 필요)
        total: dataSource.length, //전체 레코드 수(페이지 숫자 표시를 위해 필요)
      },
    });
  };

  function handleChangeStatus(value) {
    setFilter({ ...filter, status: value });
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination, current:1
      }
    })
  }
  function dateChange(value) {
    if (value === null) {
      setFilter({ ...filter, dateRange: null });
    } else {
      const hour = new Date(value[0]._d).getHours() * 60 * 60 * 1000
      const minute = new Date(value[0]._d).getMinutes() * 60 * 1000
      const second = new Date(value[0]._d).getSeconds() * 1000
      const oneDay = 60 * 60 * 24 * 1000
      
      const start = new Date(value[0]._d - hour - minute - second)
      const end = new Date(value[1]._d - hour - minute - second + oneDay)
      setFilter({ ...filter, dateRange: [start, end] });
      setTableParams({
        ...tableParams,
        pagination: {
          ...tableParams.pagination, current:1
        }
      })
    }
  }
  function onSearch(value) {
    setFilter({ ...filter, search: value });
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination, current:1
      }
    })
  }

  useEffect(() => {
    fetchData();
  }, [JSON.stringify(tableParams), JSON.stringify(filter)]);

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      ...sorter,
    });
  };

  return (
    <div style={{display:"flex", flexDirection:"column", height:"100%"}}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "10px",
        }}
      >
        <span>메뉴접속 이력</span>
        <span>
          <DatePicker.RangePicker allowClear={true} placeholder={["시작일자","종료일자"]} style={{marginLeft:"5px"}} onChange={dateChange} />
          <Input.Search
            placeholder="계정이나 이름을 입력해주세요."
            onSearch={onSearch}
            allowClear={true}
            style={{
              width: 250,
              marginLeft: "5px"
            }}
          />
          <Select
            defaultValue="전체"
            style={{
              width: 120,
              marginLeft: "5px"
            }}
            onChange={handleChangeStatus}
            options={[
              {
                value: "전체",
                label: "계정상태:전체",
              },
              {
                value: "1",
                label: "정상",
              },
              {
                value: "0",
                label: "해지",
              },
            ]}
          />
        </span>
      </div>
      <div style={{ width:"100%", height:"100%", overflow:"auto"}}>
      <Table
        className="pageTable"
        columns={columns}
        rowKey="index"
        dataSource={data}
        pagination={tableParams.pagination}
        loading={loading}
        onChange={handleTableChange}
        scroll={{ x: 1000, y:"100%" }}
      />
      </div>
    </div>
  );
};

export default AccessMenuHistory;
